export const radioOptions = [
  { value: 'LOST', label: 'Replace the Card due to Card Lost' },
  { value: 'STOLEN', label: 'Replace the Card due to Card Stolen' },
  { value: 'DAMAGED', label: 'Replace the Card due to Physical Damage' },
];

export const DEFAULT_ACTION = '/DEFAULT_ACTION';



// WEBPACK FOOTER //
// client/containers/YesBankReplaceCard/constants.js